/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { withTranslation } from 'react-i18next'
import styles from './PermitsList.module.scss'
import { useHistory } from 'react-router-dom'
import PermitsListTable from './PermitsListTable'
import { useSelector } from 'react-redux'
import BackAnchor from '../../../../shared/components/BackAnchor'
import AddPermitView from './AddPermitView'

const PermitListView = ({ t, i18n, setIsError, reviewConfirmation }) => {
  let history = useHistory()

  const onNextClick = () => {
    history.push(`/${i18n.language}${t('routes.contact_info')}`)
  }

  const { permits } = useSelector((state) => state.app)

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <BackAnchor />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-10">
          <h1>{t('permits_list.pending_permit_renewals')}</h1>
        </div>
      </div>
      <PermitsListTable setIsError={setIsError} reviewConfirmation={reviewConfirmation} />
      <div className="col-md-10">
        <button
          className={['btn-lg btn-default', styles['next_button']].join(' ')}
          onClick={onNextClick}
          value={t('permits_list.next')}
          name={t('permits_list.next')}
        >
          {t('permits_list.next')}
        </button>
      </div>
      {
        // Only allow 10 permit renewals
        permits.length < 10 && (
          <div>
            <AddPermitView t={t} setIsError={setIsError} />
          </div>
        )
      }
    </div>
  )
}

export default withTranslation('common')(PermitListView)
